document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (event) {
  const toggle = event.target.closest('[data-mobile-menu-toggle]');
  if (!toggle) return;
  const nav = document.querySelector('[data-mobile-nav]');
  if (!nav) return;
  const isOpen = nav.getAttribute('aria-hidden') === 'false';
  nav.setAttribute('aria-hidden', String(isOpen));
  toggle.setAttribute('aria-expanded', String(!isOpen));
});

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-quantity-button]');
  if (!button) return;
  const wrapper = button.closest('[data-quantity]');
  const input = wrapper && wrapper.querySelector('input[type="number"]');
  if (!input) return;
  const change = button.dataset.quantityButton === 'plus' ? 1 : -1;
  const min = Number(input.getAttribute('min') || 0);
  const next = Math.max(min, Number(input.value || min) + change);
  input.value = next;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', function (event) {
  const selector = event.target.closest('[data-product-variant-select]');
  if (!selector) return;
  const form = selector.closest('form');
  const idInput = form && form.querySelector('[name="id"]');
  if (idInput) idInput.value = selector.value;
});
